<template>
  <multiselect
    :filterable="true"
    :options="options"
    v-model="selected"
    :custom-label="label"
    :placeholder="placeholder"
  />
</template>

<script>
import vSelect from "vue-select";

export default {
  components: {
    vSelect,
  },
  props: {
    draw: {
      type: Number,
    },
    placeholder: {
      type: String,
    },
    value: {
      type: Object,
    },
  },
  data() {
    return {
      baseUrl: "/api/sfa/v1/master/unit-of-measure",
      options: [],
      selected: null,
    };
  },
  methods: {
    get() {
      this.$http
        .get(this.baseUrl, {
          params: {
            order: "name",
            sort: "asc",
          },
        })
        .then((resp) => {
          if (resp.code === 200) {
            resp.data.records.map(function (x) {
              return (x.label = x.name);
            });

            this.options = resp.data.records;
          } else {
            this.options = [];
            console.log(resp.data);
          }
        });
    },
    label(option) {
      return option.label;
    },
  },
  watch: {
    selected(newVal) {
      this.$emit('selected', newVal);
    },
  },
  mounted() {
    this.get();
  },
};
</script>
